import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { OkOrNoFlug, YesOrNoFlug } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

const stepperData = ["届出待ち", "承認中", "完了"];

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "法人情報",
  },
  {
    title: "経営者種別",
    keyword: "businessOwnerClass",
    type: "text",
  },
  {
    title: "法人名",
    keyword: "corpName",
    type: "text",
  },
  {
    title: "法人名（ｶﾅ）",
    keyword: "corpNameKana",
    type: "text",
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    type: "text",
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "text",
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "所在地",
    keyword: "address",
    type: "text",
  },
  {
    title: "法人番号",
    keyword: "corpNumber",
    type: "text",
  },
  {
    title: "代表電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title: "代表FAX番号",
    keyword: "fax",
    type: "text",
  },
  {
    title: "履歴事項全部証明書",
    keyword: "certificate",
    type: "downloadLink",
    dataname: "履歴事項全部証明書",
    base64filedata: "fsdgfdfhdfh",
    showLine: false,
  },
  {
    title: "就業規則",
    keyword: "employmentRegulations",
    type: "downloadLink",
    dataname: "就業規則",
    base64filedata: "fsdgfdfhdfh",
    showLine: false,
  },
  {
    title: "給与規則",
    keyword: "salaryRegulations",
    type: "downloadLink",
    dataname: "給与規則",
    base64filedata: "fsdgfdfhdfh",
    showLine: false,
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "本共済契約申込み担当者情報",
  },
  {
    title: "所属部署名",
    keyword: "managerDeptName",
    type: "text",
  },
  {
    title: "役職",
    keyword: "managerPosition",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "managerName",
    type: "text",
  },
  {
    title: "電話番号",
    keyword: "managerTel",
    type: "text",
  },
  {
    title: "連絡先メールアドレス",
    keyword: "managerEmail",
    type: "text",
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: "本共済契約の契約希望日",
  },
  {
    title: "契約希望日",
    keyword: "applyDate",
    type: "date",
    disabled: true,
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "経営している主な施設の種類",
  },
  {
    title: "経営している主な施設の種類",
    keyword: "typeOffacilityOperated",
    type: "text",
    disabled: true,
    node: <></>,
  },
  {
    keyword: "title5",
    type: "lineTitle",
    lineTitle: "申込み前提事項の確認",
  },
  {
    title: "過去に退職手当共済契約を締結したことの有無",
    keyword: "pastContractFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    setDefaultValue: "0",
    disabled: true,
  },
  {
    title: "契約解除日",
    keyword: "pastContractCancelDate",
    type: "date",
    disabled: true,
    showLine: false,
  },
  {
    title: "中小企業退職共済契約を締結していることの有無",
    keyword: "contractFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    disabled: true,
  },
  {
    title: "給与支払遅滞の有無",
    keyword: "salaryPaymentDelayFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
];
const schema = {};

const headTitleList: any[] = [
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "職員情報登録",
  },
];

const headTitleList2: any[] = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

export { schema, stepperData, fakeTableList, headTitleList, headTitleList2 };
